// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class QuickBooksAccount extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
    return `${this.quickBooksAccountNumber ? `${this.quickBooksAccountNumber} -` : ''} ${this.name ?? ''}`;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  active!: boolean;
  classification?: string;
  deleted?: Date;
  description?: string;
  isVisible!: boolean;
  name?: string;
  quickBooksAccountNumber?: string;
  quickBooksId?: string;
  quickBooksLastUpdate?: Date;
  subAccount!: boolean;
}

